<template>
  <div class="pipeline_note flex">
    <icon-default
      icon="note"
      color="is-note"
      size="is-small"
      class="mt-25"
    ></icon-default>

    <div class="flex-grow ml-50">
      <h3 class="pipeline_note--title">{{ title }}</h3>

      <p class="pipeline_note--subtitle flex flex-between">
        {{ date }}
        <button-link
          v-if="canEdit"
          class="is-inline-block"
          @click="$refs.noteFormModal.open(note)"
        >edit note
        </button-link>
      </p>

      <div class="pipeline_note--body content mb-0" v-html="note.body"></div>
    </div>

    <modal-container>
      <modal-crud-form
        ref="noteFormModal"
        title="Note"
        form-component="note-form"
        hide-delete-button
      ></modal-crud-form>
    </modal-container>
  </div>
</template>

<script>

import dates from "../../../../../services/dates";

export default {
  name: "ContactingNote",
  props: {
    note: {
      type: Object,
      required: true
    }
  },
  computed: {
    canEdit() {
      const createdBy = this.note.createdBy;

      // If a note is not created by a user then it is always editable
      if (createdBy.class_name !== "App\\Models\\User") {
        return true;
      }

      // Notes created by a user can only be edited by that user
      return this.$store.state.activeUser.id === createdBy.id;
    },
    title() {
      const createdByName = this.note.createdBy.display_name;

      if (this.note.is_modified) {
        return (this.note.is_different_user)
          ? `${createdByName} (edited by ${this.note.updatedBy.display_name})`
          : `${createdByName} (edited)`;
      }

      return createdByName;
    },
    date() {
      return dates.formatAsDateTime(this.note.created_at);
    },
  }
};
</script>

<style lang="scss" scoped>
@import "../../../../../styles/variables/variables";

.pipeline_note {
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid $border;

  &--title {
    margin-bottom: 4px;
  }

  &--subtitle {
    color: $text-muted;
    font-size: 0.875em;
  }

  &--body {
    margin-top: 12px;
    font-style: italic;
  }
}
</style>
